import { createFileRoute } from '@tanstack/react-router';

import { BookingPrimaryPage } from '@/features/booking/BookingPrimaryPage';

export const Route = createFileRoute(
	'/$missionId/search-results/$searchId/booking/$mobilitySolutionId/$bookingId/primary/',
)({
	component: RouteComponent,
});

function RouteComponent() {
	const { missionId } = Route.useParams();

	return <BookingPrimaryPage missionId={missionId} />;
}
